import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Dialog, Divider, IconButton, Stack } from "@mui/material";
import React from "react";

import booking_svg from "../../../assets/bookingLink.svg";
import copy_squares from "../../../assets/square.on.square.svg";
import { useToast } from "../../../provider/ToastProvider";

export default function ServiceBookingLinkModal({
  title,
  errorMsg = "Sorry for the inconvenience, The Payment Link was not Generated. Please try again",
  subtitle,
  open,
  handleClose,
  bookingLink,
}) {
  const [copyText, setCopyText] = React.useState("Copy");
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  return (
    <Dialog
      open={open}
      scroll={"body"}
      PaperProps={{
        sx: {
          borderRadius: 5,
          minWidth: 550,
          maxWidth: 550,
          overflowX: "hidden",
          backgroundColor: "primary.main",
        },
      }}
    >
      {bookingLink ? (<Stack direction={"column"} spacing={6} sx={{ pt: 4, pb: 8, px: 8 }}>
        <Stack direction={"column"} spacing={2}>
          <div className={"flex flex-row items-center justify-between"}>
            <h3 className={"font-bold text-2xl text-white"}>{title !== undefined ? title : `Share Booking Link`}</h3>
            <IconButton onClick={handleClose}>
              <CloseRoundedIcon sx={{ color: "#FFF" }} />
            </IconButton>
          </div>
          <Divider variant={"middle"} sx={{ color: "primary.light" }} />
        </Stack>
        <Stack direction={"column"} spacing={1}>
          <img src={booking_svg} alt={""} />
          <p className={"font-medium text-[16px] text-center text-white"}>
            {subtitle !== undefined ? subtitle : `Payment Link Generated`}
          </p>
        </Stack>
        <button
          className={
            "min-w-[340px] h-[58px] bg-white rounded-xl flex flex-row items-center justify-center gap-2 px-4 py-2"
          }
          onClick={async () => {
            try {
              await navigator.clipboard.writeText(bookingLink);
              addSuccessToast("Copied!");
            } catch (e) {
              addErrorToast("Failed to copy!");
            }
          }}
        >
          <span className={"h-[50px] flex-1 flex items-center justify-center font-semibold text-brown-coffee text-ellipsis overflow-hidden cursor-pointer break-all"}>
            {bookingLink}
          </span>
          <span className={"flex flex-col items-center"}>
            {/* {copyText == "Copy" ? (<img src={copy_squares} alt={""} />) : ( */}
            {copyText == "Copy" ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z" stroke="#FF5733" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15L14 17L18 13M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z" stroke="#FF5733" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            )}
            <p className={"text-[10px] font-semibold text-black"}>{copyText}</p>
          </span>
        </button>
      </Stack>) : (
        <Stack direction={"column"} spacing={2} sx={{ pt: 4, pb: 8, px: 8 }}>
          <Stack direction={"column"} spacing={2}>
            <div className={"flex flex-row items-center justify-between"}>
              <h3 className={"font-bold text-2xl text-white"}>&nbsp;</h3>
              <IconButton onClick={handleClose}>
                <CloseRoundedIcon sx={{ color: "#FFF" }} />
              </IconButton>
            </div>
            <Divider variant={"middle"} sx={{ color: "primary.light" }} />
          </Stack>
          <Stack direction={"column"} spacing={1}>
            <p className={"font-medium text-[16px] text-center text-white"}>
              {errorMsg}
            </p>
          </Stack>
        </Stack>
      )}
    </Dialog>
  );
}
